import groq from 'groq';

import { ASSET } from './asset';
import { CAPTIONS_VIDEO } from './captionsVideo';
import { CLOUDINARY_VIDEO } from './cloudinaryVideo';
import { RICH_TEXT } from './richText';
import { STUDY_MODAL } from './studyModal';

export const BENEFITS_PAGE_ITEM = groq`
  _key,
  _type,
  title,
  description[] {
    ${RICH_TEXT}
  },
  statistic,
  disclaimer,
  "thumbnail": thumbnail[0]{
    _type,
    _type == 'altImage' => {
      ${ASSET}
    },
    _type == 'gif' => {
      ${CLOUDINARY_VIDEO},
      poster { ${ASSET} }
    }
  },
  video {
    ${CAPTIONS_VIDEO},
  },
  scientificJournal {
    ${ASSET}
  },
  modal->{
    ${STUDY_MODAL}
  }
`;
